/**
 * Rückfrage „Hat der Kunde das Angebot angenommen?" beim Planen (Benjamin,
 * 15.10.2026: „wenn Termine geplant werden für das Projekt, muss nachgefragt
 * werden — normalerweise machen wir das erst, wenn das Angebot bestätigt wurde").
 *
 * Termine entstehen an mehreren Stellen (Planer, Tagesleiste, Arbeitsplan,
 * Teamseite). Statt die Frage in jede einzubauen, stößt jede nur an; das Blatt
 * `AngebotAnnahmeFrage` in der Shell hört zu, fragt den Server nach offenen
 * Angeboten und zeigt sich nur, wenn es wirklich eins gibt.
 */
export const ANGEBOT_FRAGE_EVENT = "kontor:angebot-frage";

export function angebotFrageAnstossen(projektId?: string | null) {
  if (!projektId || typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ANGEBOT_FRAGE_EVENT, { detail: { projektId } }));
}

const SCHLUESSEL = "kontor.angebotFrage.nein";

/** „Noch nicht" gilt für diese Sitzung — sonst fragt jeder weitere Termin erneut. */
export function schonVerneint(projektId: string, nummern: string[]): boolean {
  try {
    const liste: string[] = JSON.parse(sessionStorage.getItem(SCHLUESSEL) || "[]");
    return nummern.every((n) => liste.includes(`${projektId}:${n}`));
  } catch {
    return false;
  }
}

export function verneinen(projektId: string, nummern: string[]) {
  try {
    const liste: string[] = JSON.parse(sessionStorage.getItem(SCHLUESSEL) || "[]");
    const neu = Array.from(new Set([...liste, ...nummern.map((n) => `${projektId}:${n}`)]));
    sessionStorage.setItem(SCHLUESSEL, JSON.stringify(neu.slice(-200)));
  } catch {
    /* ohne Speicher fragt das Blatt eben beim nächsten Termin wieder */
  }
}
